import React, { useEffect, useState } from 'react'
import { useCustomComponentStore, type RemoteComponentProps } from '../../../stores/customComponentsStore'
globalThis.React = React

declare global {
  interface Window {
    RemoteComponents: Record<string, React.FC<any>>
  }
}

type CustomComponentProps = {
  url: string
  name: string
  data?: any
}

export const CustomComponent = ({ url, name, data, ...props }: CustomComponentProps & RemoteComponentProps) => {
  const fetchComponent = useCustomComponentStore((state) => state.getCustomComponent)
  const [Component, setComponent] = useState<React.FC<RemoteComponentProps> | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    fetchComponent(url)
      .then(setComponent)
      .catch((err) => {
        setError(err.message)
      })
  }, [url])

  if (error) return <div style={{ color: 'red' }}>{error}</div>
  return Component ? <Component {...data} {...props} /> : null
}
